



























import { SiteDomain, SiteDomainConfiguration } from "@/model/site-domain";
import { Util } from "@/util/util";
import Vue from "vue";
import DomainItem from "./domain-item/DomainItem.vue";

export default Vue.extend({
	name: "DomainSwitcher",
	components: {
		"domainItem": DomainItem
	},
	props: {
		loggedIn: {
			type: Boolean,
			required: false,
			default: false
		},
		loginPageLink: {
			type: String,
			required: true
		}
	},
	data() {
		return <{
			siteDomainConfiguration: SiteDomainConfiguration | null
			languageSelectorActive: boolean
			linkSuffix: String
		}>{
			siteDomainConfiguration: null,
			languageSelectorActive: false,
			linkSuffix: ""
		};
	},
	created(): void {
		this.setSiteDomainConfiguration();
	},
	mounted(): void {
		if (this.loggedIn) {
			this.linkSuffix = this.loginPageLink;
		}
	},
	methods: {
		setSiteDomainConfiguration() {
			this.siteDomainConfiguration = Util.getSiteDomainConfiguration();
		},

		setLanguageSelector(): void {
			this.languageSelectorActive = !this.languageSelectorActive;
		},

		getLanguageLinkWithLogin(locale: SiteDomain): String {
			return locale.link + this.linkSuffix + "&ui_locales=" + locale.language;
		}
	}
});
